module.exports = __webpack_public_path__ + "static/media/secondareaproduct4.aa026d22.jpg";